export default class Header {

  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.menu = el.querySelector('.header--menu')
    this.menuClose = el.querySelector('.header--menu-close')
    this.nav = el.querySelector('.header--nav')
    this.hero = document.querySelector('.hero, .hero-slider, .hero-search')
    // Couleurs de fond sombres : le header doit passer en variante claire (is-white)
    // par-dessus, sinon son texte (color: $color-5) se fond dans le fond
    this.darkColors = ['primary', '4', '5', '6', '7']

    this.bindScroll()
    this.bindLang()
    this.bindMenu()
    this.bindReservation()
    this.updateNavClasses()
  }

  isMenuOpen() {
    return this.menu?.classList.contains('is-full')
  }

  isOverDarkSection() {
    const rect = this.nav.getBoundingClientRect()
    const probeY = rect.top + rect.height / 2
    // elementsFromPoint car le point tombe souvent sur le logo/burger (pointer-events: all)
    // du header lui-même : on cherche le 1er élément qui n'appartient pas au header
    const stack = document.elementsFromPoint(window.innerWidth / 2, probeY)
    const el = stack.find(node => !node.closest('.header'))
    const section = el?.closest('[class*="colored--"]')
    return !!section && this.darkColors.some(c => section.classList.contains(`colored--${c}`))
  }

  updateNavClasses() {
    if (!this.nav) return

    if (this.isMenuOpen()) {
      this.nav.classList.add('is-white')
      this.nav.classList.remove('is-scrolled')
      return
    }

    let onHero = false

    if (this.hero) {
      const heroRect = this.hero.getBoundingClientRect()
      const navHeight = this.nav.getBoundingClientRect().height
      // le hero peut ne pas être le 1er bloc de la page (ex: page Chambres) :
      // il faut être arrivé à sa hauteur, pas juste avant sa fin
      onHero = heroRect.top <= navHeight && heroRect.bottom > navHeight
    }

    this.nav.classList.toggle('is-white', onHero || this.isOverDarkSection())
    this.nav.classList.toggle('is-scrolled', window.scrollY > 30)
  }

  openMenu() {
    this.menu?.classList.add('is-full')
    this.hamburger?.classList.add('is-active')
    this.hamburger?.setAttribute('aria-expanded', 'true')
    this.el.classList.add('is-menu-open')

    this.revealItems()
    window.lenis?.stop()
    this.updateNavClasses()
  }

  closeMenu() {
    this.hideItems()

    this.menu?.classList.remove('is-full')
    this.hamburger?.classList.remove('is-active')
    this.hamburger?.setAttribute('aria-expanded', 'false')
    this.el.classList.remove('is-menu-open')

    window.lenis?.start()
    this.updateNavClasses()
  }

  revealItems() {
    const items = [...this.menu.querySelectorAll('.header--menu-list li')]
    items.forEach((li, i) => {
      li.style.transitionDelay = `${250 + i * 60}ms`
      li.classList.add('is-visible')
    })
  }

  hideItems() {
    if (!this.menu) return
    const items = [...this.menu.querySelectorAll('.header--menu-list li')]
    items.forEach(li => {
      li.style.transitionDelay = '0ms'
      li.classList.remove('is-visible')
    })
  }

  bindMenu() {
    if (!this.hamburger) return

    this.hamburger.addEventListener('click', () => {
      this.isMenuOpen() ? this.closeMenu() : this.openMenu()
    })

    this.menuClose?.addEventListener('click', () => this.closeMenu())
  }

  bindReservation() {
    this.reservationTrigger = this.el.querySelector('[data-panel-target="reservation"]')
    this.reservationPanel = this.el.querySelector('.header--reservation-panel')
    this.reservationClose = this.reservationPanel?.querySelector('.header--reservation-close')
    this.reservationOverlay = this.el.querySelector('.header--reservation-overlay')

    if (!this.reservationTrigger || !this.reservationPanel) return

    this.reservationTrigger.addEventListener('click', () => this.openReservation())
    this.reservationClose?.addEventListener('click', () => this.closeReservation())
    this.reservationOverlay?.addEventListener('click', () => this.closeReservation())
  }

  openReservation() {
    this.reservationPanel.classList.add('is-open')
    this.reservationOverlay?.classList.add('is-open')
    window.lenis?.stop()
  }

  closeReservation() {
    this.reservationPanel.classList.remove('is-open')
    this.reservationOverlay?.classList.remove('is-open')
    window.lenis?.start()
  }

  bindLang() {
    const items = [...this.el.querySelectorAll('.header--lang-item')]
    if (!items.length) return

    const setActive = (lang) => {
      items.forEach(l => l.classList.toggle('is-active', l.getAttribute('hreflang') === lang))
    }

    const pathMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/)
    if (pathMatch) setActive(pathMatch[1])

    if (typeof Weglot !== 'undefined') {
      Weglot.on('languageChanged', (lang) => setActive(lang))
    }

    items.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        setActive(link.getAttribute('hreflang'))
        window.location.href = link.dataset.href || link.href
      })
    })
  }

  bindScroll() {
    window.addEventListener('scroll', () => this.updateNavClasses(), { passive: true })
  }

}
